module.exports = __webpack_public_path__ + "img/statement_a.9d3c90ba.png";